import http from "../utils/http";

export function getList(params) {
    return http({
        method: "post",
        url: "/xj/roster/paging",
        params
    });
}

export function add(params) {
    return http({
        method: "post",
        url: "/xj/roster/add",
        data: params
    });
}

export function edit(params) {
    return http({
        method: "post",
        url: "/xj/roster/update",
        data: params
    });
}


export function downloadExcel() {
    return http({
        method: "get",
        url:"/xj/roster/whitelistTemplate/find"
    });
}

export function fileExport() {
    return http({
        method: "get",
        url:"/xj/roster/exportRoster"
    });
}

export function delData(params) {
    return http({
        method: "post",
        url: "/xj/roster/delete",
        data: params
    });
}
export function uploadFile(params) {
    return http({
        method: "post",
        url: "/xj/roster/importRoster",
        data:params
    });
}
